export const ROLE_FULFILLMENT_ADMIN = 'fulfillmentservice.ADMIN'

export const SERVICE_FULFILLMENT = 'fulfillment-service'

export const SERVICE_INTEGRA_COMMERCE_API = 'IntegraCommerceApi'

export const SERVICE_MARKET_MATCHER = 'ps-core-channel-market-matcher'

export const SERVICE_PRODUCT_API_PRODUCT = 'product-api-product'

export const ROLE_NEW_PRODUCT_REGISTER = 'NEW_PRODUCT_REGISTER'

export const roles = [ROLE_FULFILLMENT_ADMIN]

export const services = [SERVICE_FULFILLMENT]
